import styled from 'styled-components';
import React from 'react';

const Label = styled.div`
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    transform-origin: 0 0;
    transition: all 0.2s ease;
`;

const Input = styled.textarea`
    background: transparent;
    border: none;
    font-family: inherit;
    font-size: inherit;
    margin-top: 3px;
    min-height: 150px;
    outline: none;
    resize: vertical;
    width: 100%;

    &:focus,
    &:not(:placeholder-shown) {
        + ${Label} {
            opacity: 0.65;
            transform: scale(0.85) translateY(-0.625em) translateX(4px);
        }
    }
`;

const Container = styled.label`
    && {
        border-radius: calc(var(--cr-button-rounding) * 0.6666);
        padding: 1.125em 1.25em 0.75em;
        position: relative;
    }
`;

type TextAreaProps = {
    text: string;
    setText: React.Dispatch<React.SetStateAction<string>>;
    placeholder: string;
    label: string;
    isRequired?: boolean;
};

const TextArea: React.FC<TextAreaProps> = ({ text, setText, placeholder, label , isRequired}) => {
    return (
        <Container className='cr-border cr-border-primary'>
            <Input
                placeholder={placeholder}
                value={text}
                onChange={(e) => setText(e.target.value)}
                required={isRequired}
            />
            <Label className='cr-pill cr-border-transparent'>
                {label}
            </Label>
        </Container>
    );
}

export default TextArea;
